<template>
<div class="content">
    <div class="container-fluid">
    <div class="row">
        <div class="col-md-12">
        <employee-list>
        </employee-list> 
        </div>
    </div>  
    </div>
</div>
</template>
<script>
/* eslint-disable */
import EmployeeList from './todo-employee-list'
export default {
    components: {
        EmployeeList
    }
}
</script>
<style lang="scss">
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/bp-employee-management/base-employee-list.vue